// @flow
import { InstancesInternalFormsActionTypes } from './constants';

const INIT_STATE = {
    instance: {},
    listaInstances: [],
    loading: false,
    error: false,
    formSubmited: false
};

type InstancesInternalFormsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { instance?: {} | null, listaInstances?: [] | null, loading?: boolean, +value ?: boolean };

const InstancesInternalForms = (state: State = INIT_STATE, action: InstancesInternalFormsAction): any => {
    // console.log(action);
    switch (action.type) {
        case InstancesInternalFormsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case InstancesInternalFormsActionTypes.GET_INSTANCE_INTERNAL_FORM: {
                    return {
                        ...state,
                        instance: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case InstancesInternalFormsActionTypes.LIST_INSTANCES_INTERNAL_FORMS: {
                    return {
                        ...state,
                        listaInstances: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case InstancesInternalFormsActionTypes.ADD_INSTANCE_INTERNAL_FORM: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case InstancesInternalFormsActionTypes.UPDATE_INSTANCE_INTERNAL_FORM: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case InstancesInternalFormsActionTypes.DELETE_INSTANCE_INTERNAL_FORM: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case InstancesInternalFormsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case InstancesInternalFormsActionTypes.GET_INSTANCE_INTERNAL_FORM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        instance: {},
                        loading: false,
                    };
                }
                case InstancesInternalFormsActionTypes.LIST_INSTANCES_INTERNAL_FORMS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaInstances: [],
                        loading: false,
                    };
                }
                case InstancesInternalFormsActionTypes.ADD_INSTANCE_INTERNAL_FORM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case InstancesInternalFormsActionTypes.UPDATE_INSTANCE_INTERNAL_FORM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case InstancesInternalFormsActionTypes.DELETE_INSTANCE_INTERNAL_FORM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case InstancesInternalFormsActionTypes.GET_INSTANCE_INTERNAL_FORM:
            return { ...state, error: false, loading: true };
        case InstancesInternalFormsActionTypes.LIST_INSTANCES_INTERNAL_FORMS:
            return { ...state, error: false, loading: true };
        case InstancesInternalFormsActionTypes.ADD_INSTANCE_INTERNAL_FORM:
            return { ...state, error: false, loading: true };
        case InstancesInternalFormsActionTypes.UPDATE_INSTANCE_INTERNAL_FORM:
            return { ...state, error: false, loading: true };
        case InstancesInternalFormsActionTypes.DELETE_INSTANCE_INTERNAL_FORM:
            return { ...state, error: false, loading: true };
        case InstancesInternalFormsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                instance: {},
                listaInstances: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default InstancesInternalForms;
